import type { IAction } from '@/types/api/IAction'

export const authActions = {
  attemptLogin: {
    id: 'attemptLogin',
    successMessage: 'Successfully logged in.',
    errorMessage: 'There was an error logging in.',
  } as IAction,
  logout: {
    id: 'logout',
    successMessage: 'Successfully logged out.',
    errorMessage: 'There was an error logging out.',
  } as IAction,
  updateAuthenticatedUserProfile: {
    id: 'updateAuthenticatedUserProfile',
    successMessage: 'Successfully updated user.',
    errorMessage: 'There was an error updating user.',
  } as IAction,
  updateAuthenticatedUserPassword: {
    id: 'updateAuthenticatedUserPassword',
    successMessage: 'Successfully changed password.',
    errorMessage: 'There was an error changing password.',
  } as IAction,
  getAuthenticatedUserProfile: {
    id: 'getAuthenticatedUserProfile',
    successMessage: 'Successfully fetched user profile.',
    errorMessage: 'There was an error fetching user profile.',
  } as IAction,
}
